var map = {
	"./img_bask_map.png": 2895,
	"./img_datum.png": 1673,
	"./img_gaiac.png": 3778,
	"./img_last.png": 3375,
	"./img_narrabilis.png": 4920,
	"./img_rasul.png": 6857,
	"./img_title_datum.png": 9995,
	"./img_title_gaiac.png": 706,
	"./img_title_last.png": 6665,
	"./img_title_narrabilis.png": 5548,
	"./img_title_rasul.png": 9567,
	"./intro.png": 1162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5820;